import gql from "graphql-tag";

export const MY_TIMESHEET_GET_GROUPED_BY_USERS_LIST = gql`
  query groupedByUsersMySheetList(
    $page: Int!
    $pageSize: Int!
    $startTime: Date!
    $endTime: Date!
    $roleFilters: RoleFilterInput
    $role: String
  ) {
    groupedByUsersMySheetList(
      page: $page
      pageSize: $pageSize
      startTime: $startTime
      endTime: $endTime
      roleFilters: $roleFilters
      role: $role
    ) {
      page
      pageSize
      total
      totalPages
      rows {
        _id
        employeeCode
        employeeName
        contractId
        projectName
        clientName
        startTime
        endTime
        state
      }
    }
  }
`;
